module.exports = __webpack_public_path__ + "static/media/loading.7c0698a6.svg";